import React, { FC } from 'react';

// components
import { TextInput } from 'src/components/Inputs';

// helpers
import { getRequiredMessage } from 'src/lib/utils';

import { FormSectionTextInputProps } from './FormSectionTextInput.types';

const FormSectionTextInput: FC<FormSectionTextInputProps> = ({
  data,
  errors,
  register,
  pattern = {},
  required,
  defaultValue,
  className,
  labelClassName,
  inputClassName,
  placeholder,
  isDarkMode,
}) => {
  return (
    <TextInput
      className={className}
      labelClassName={labelClassName}
      inputClassName={inputClassName}
      label={data.label}
      placeholder={placeholder}
      isDarkMode={isDarkMode}
      id={data.name}
      name={data.name}
      describedby={data.describedby}
      errorMessage={errors?.[data.name]?.message}
      register={register}
      {...(required && { required: getRequiredMessage(data.label) })}
      autoComplete={data.autoComplete}
      {...(pattern && { pattern: { ...pattern } })}
      defaultValue={defaultValue}
    />
  );
};

export default FormSectionTextInput;
